export type FilterMatches<T> = { filtered: T[]; matched: T[] };
export class SearchBarHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static filterItems<T extends { [key: string]: any; children?: T[] }>(
    items: T[],
    searchTerm: string,
    key: keyof T,
  ): FilterMatches<T> {
    if (!searchTerm) return { filtered: items, matched: [] };

    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const filterRecursive = (items: T[]): FilterMatches<T> =>
      items.reduce<FilterMatches<T>>(
        (acc, item) => {
          const itemValue = item[key]?.toString() ?? '';
          const itemText = itemValue.toLowerCase();
          const isMatch = itemText.includes(lowerCaseSearchTerm);

          const children = item.children;
          const filteredChildren = filterRecursive(children ?? []);
          acc.matched.push(...filteredChildren.matched);

          if (isMatch) {
            acc.filtered.push(item);
            acc.matched.push(item);
          } else if (filteredChildren.filtered.length > 0) {
            acc.filtered.push({ ...item, children: filteredChildren.filtered });
          }

          return acc;
        },
        { filtered: [], matched: [] },
      );

    return filterRecursive(items);
  }
}
